import { ref } from 'vue'

import { TOAST_DURATION, TOAST_TYPE } from '../config/toast.config.js'

const toasts = ref([])
const timers = new Map()
let nextId = 0

function show(message, variant = TOAST_TYPE.SUCCESS) {
  const id = nextId++
  toasts.value.push({ id, message, variant })
  if (TOAST_DURATION > 0) timers.set(id, setTimeout(() => dismiss(id), TOAST_DURATION))
  return id
}

function dismiss(id) {
  const timer = timers.get(id)
  if (timer) {
    clearTimeout(timer)
    timers.delete(id)
  }
  toasts.value = toasts.value.filter((toast) => toast.id !== id)
}

function success(message) {
  return show(message, TOAST_TYPE.SUCCESS)
}

function error(message) {
  return show(message, TOAST_TYPE.ERROR)
}

function warning(message) {
  return show(message, TOAST_TYPE.WARNING)
}

function info(message) {
  return show(message, TOAST_TYPE.INFO)
}

export function useToast() {
  return {
    toasts,
    show,
    dismiss,
    success,
    error,
    warning,
    info,
  }
}
